import { TeamId, FundraisingPrize, AccountInfo, PlayerId } from "@ollie-sports/models";
import moment from "moment";
import { getFlexPrismaClient } from "../../helpers";
import { maybeRefreshFlexPlayer } from "./helpers/maybeRefreshFlexPlayer";

export async function flex__server__maybeRefreshFlexPlayer(p: { accountInfo: AccountInfo; playerId: PlayerId }) {
  return maybeRefreshFlexPlayer(p);
}
flex__server__maybeRefreshFlexPlayer.auth = () => {};
